import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import { Box, Menu, MenuItem, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { Link } from "react-router-dom";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { loginRequest } from "../../authConfig";
import useFetchWithMsal from "../../utils/useFetchWithMsal";
import {
  LogoContainer,
  NavBar,
  NavigationBarButton,
  NavigationBarContainer,
  NavigationBarUser,
} from "./NavigationBar.styled";
import { useEffect, useState } from "react";
import { naicMemberRoleCheck } from "../../shared/utils/permissions";
import { setRoleId, setUserId } from "../../store/slices/UserSlice";
import { useDispatch, useSelector } from "react-redux";

const StyledLink = styled(Link)(({ theme }) => ({
  font: '400 20px Oswald',
  color: "#fff",
  textDecoration: "none",
  alignItems: "center",
  display: "flex",
  height: "30px",
}));
const StyledMenu = styled(Menu)({

  "& .MuiMenu-paper, .MuiMenu-list": {
    width: "150px",
  },

});
const AuthenticatedNavBar = () => {
  const { skip } = useFetchWithMsal();
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();

  const open = Boolean(anchorEl);

  const userData = activeAccount?.idTokenClaims.extension_userAccessInfo && JSON.parse(activeAccount?.idTokenClaims.extension_userAccessInfo);

  useEffect(() => {
    dispatch(setUserId(userData?.UserInternalId))
    dispatch(setRoleId(userData?.["RoleId"]))
  }, [userData?.["RoleId"]]);

  const roleId = useSelector((state) => state?.user?.roleId);

  const handleOpenRoleDropdown = (event) => {
    roleId === 1 && setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogoutRedirect = () => {
    instance.logoutRedirect();
  };

  return (
    <>
      <NavigationBarContainer>
        <StyledLink to="/">
          {"Illinois Life & Health Insurance Guaranty Association"}
        </StyledLink>
        <Box display="flex">
{/*           <NavigationBarUser onClick={handleOpenRoleDropdown}>
            <AccountCircleIcon />

          </NavigationBarUser>
          <StyledMenu
            id="menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
              sx: { width: anchorEl && anchorEl.offsetWidth },
            }}
          >
          </StyledMenu> */}
          <NavigationBarButton
            onClick={handleLogoutRedirect}
            variant="outlined"
          >
            {/* <SignOut24Regular /> */}
            Sign out
          </NavigationBarButton>
        </Box>
      </NavigationBarContainer>
      <LogoContainer>
        <div>
        </div>
      </LogoContainer>
    </>
  );
};

export const NavigationBar = () => {
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const handleLoginRedirect = () => {
    instance.loginRedirect(loginRequest).catch((error) => console.log(error));
  };
  return (
    <>
      <NavBar>
        <AuthenticatedTemplate>
          <AuthenticatedNavBar />
        </AuthenticatedTemplate>
        <UnauthenticatedTemplate>
          <NavigationBarContainer>
            <StyledLink to="/">
              {"Illinois Life & Health Insurance Guaranty Association"}
            </StyledLink>
            <NavigationBarUser>
              <Typography margin={"0 8px"}>
                {activeAccount?.idTokenClaims.given_name || ""}
              </Typography>
            </NavigationBarUser>
            <NavigationBarButton
              onClick={handleLoginRedirect}
              variant="outlined"
            >
              {/* <SignOut24Regular /> */}
              Sign in
            </NavigationBarButton>
          </NavigationBarContainer>
        </UnauthenticatedTemplate>
      </NavBar>
    </>
  );
};



